import moment from 'moment'

export default class Statistic {
  /**
   * Create new statistic and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map data points to Datapoint if there are Datapoints
    this.datapoints = typeof this.datapoints !== 'undefined' ? this.datapoints.map(datapoint => new Datapoint(datapoint)) : []
  }

  /**
   * @return {Date}
   */
  get startDate () {
    return this._startDate
  }

  /**
   * @param {string} value
   */
  set startDate (value) {
    this._startDate = moment(new Date(value))
  }

  /**
   * @return {Date}
   */
  get endDate () {
    return this._endDate
  }

  /**
   * @param {string} value
   */
  set endDate (value) {
    this._endDate = moment(new Date(value))
  }
}

export class Datapoint {
  /**
   * Create new datapoint and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  get startDate () {
    return this._startDate
  }

  set startDate (value) {
    this._startDate = moment(new Date(value))
  }

  /**
   * @return {Date}
   */
  get endDate () {
    return this._endDate
  }

  /**
   * @param {string} value
   */
  set endDate (value) {
    this._endDate = moment(new Date(value))
  }
}
